import { forwardRef, useCallback } from 'react'
import { useTranslate } from 'react-polyglot'
import { Button, Snackbar as ChameleonSnackbar } from '@getgo/chameleon-web-react-wrapper'
import { SnackbarContent, useSnackbar } from 'notistack'

interface SnackbarProps {
  id: string | number
  message: string
  description?: string
  isPersistent?: boolean
}

const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>((props, ref) => {
  const { closeSnackbar } = useSnackbar()
  const t = useTranslate()

  const handleDismiss = useCallback(() => {
    closeSnackbar(props.id)
  }, [props.id, closeSnackbar])

  return (
    <SnackbarContent ref={ref}>
      <ChameleonSnackbar
        title={props.message}
        actions={
          props.isPersistent ? (
            <Button variant="inverted" onClick={handleDismiss}>
              {t('Dismiss')}
            </Button>
          ) : (
            <></>
          )
        }
      >
        {props.description}
      </ChameleonSnackbar>
    </SnackbarContent>
  )
})

export default Snackbar
